import { service } from 'config';
import Layout from 'components/general/Layout';
import useData from 'hooks/useData';
import { groupBy, formatDate, isCurrent } from 'utils';
import NoData from 'components/general/NoData';

export default function PreachingPublic (): JSX.Element {
    const { data: allData } = useData(service, 'Carritos');
    const rawData = allData as any;

    const titles = rawData?.length ? rawData[0].c.map((item: any) => item?.v ?? '').filter((item: string) => item.length).splice(2) : [];
    const titleMap = titles.reduce((acc: any, title: string, index: number) => {
        const key = `carrito${(index + 1).toString().padStart(2, '0')}`;
        acc[key] = title;
        return acc;
    }, {});

    const rows: any[] = rawData?.map((item: any) => ({
        fecha: item.c[0]?.v ||'',
        hora: item.c[1]?.v ||'',
        carrito01: item.c[2]?.v ||'',
        carrito02: item.c[3]?.v ||'',
        carrito03: item.c[4]?.v ||'',
        carrito04: item.c[5]?.v ||'',
        carrito05: item.c[6]?.v ||'',
        carrito06: item.c[7]?.v ||'',
        carrito07: item.c[8]?.v ||'',
        carrito08: item.c[9]?.v ||'',
        carrito09: item.c[10]?.v ||'',
        carrito10: item.c[11]?.v ||'',
        carrito11: item.c[12]?.v ||'',
        carrito12: item.c[13]?.v ||'',
        carrito13: item.c[14]?.v ||'',
        carrito14: item.c[15]?.v ||'',
        carrito15: item.c[16]?.v ||'',
        carrito16: item.c[17]?.v ||'',
        carrito17: item.c[18]?.v ||'',
        carrito18: item.c[19]?.v ||'',
        carrito19: item.c[20]?.v ||'',
        carrito20: item.c[21]?.v ||'',
    })) || [];

    const grouped = groupBy(rows, 'fecha');

    const data = [];

    for (const ii in grouped) {
        data.push({
            fecha: ii,
            servicio: grouped[ii],
        });
    }

    const currentData = data.filter((item: any) => isCurrent(item.fecha));

    console.log({currentData});
    return (
        <Layout title="Carritos">
            {!currentData.length && (
                <NoData />
            )}
            {currentData.map((item: any) => {
                const hasAnyService = item.servicio.some((ss: any) => 
                    ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20'].some((num) => ss[`carrito${num}`])
                );
                
                if (!hasAnyService) return null;
                
                return (
                    <div key={item.fecha}>
                        <div className="block-container">
                            <div className="service-container">
                                <div className="date">{formatDate(item.fecha)}</div>
                                <ul>
                                    {item.servicio.map((ss: any, index: number) => {
                                        const hasAnyCarrito = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20'].some((num) => ss[`carrito${num}`]);
                                        
                                        if (!hasAnyCarrito) return null;
                                        
                                        return (
                                            <li key={index} className="mx-2">
                                                <span className="hora">{ss.hora}</span>

                                                {['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20'].map((num) => (
                                                    ss[`carrito${num}`] && (
                                                        <div key={num}>
                                                            <div className="titulo" style={{textTransform: 'none', fontWeight: '100', fontStyle: 'italic'}}>{titleMap[`carrito${num}`]}</div>
                                                            <div style={{marginLeft: '20px', fontWeight: 'bold'}}>{ss[`carrito${num}`]}</div>
                                                        </div>
                                                    )
                                                ))}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                );
            })}
        </Layout>
    );
}
